###*
  * Encapsulates initializers for different select2 configurations
  * Used by SettingsManager
###

class INTENT.report.Select2Helper

  constructor: (@parent) ->
    @controller = @parent.controller
    @select2_token_separators = [',', ' ']
    @url_get_list = '/livereports/get_object_list'

  init_editor: (select, options) =>
    select.attr "data-widget-select2-editor", options
    select.attr 'data-autoinited', true
    new INTENT.widgets.Select2Editor select

  init_select2_plain: (select, initial_values) =>
    select.destroySelect2 clear:true
    options = {
      tags: true,
      tokenSeparators: @select2_token_separators,
      minimumInputLength: 0
    }
    if initial_values?
      options.data = initial_values.map (id) =>
        id: id,
        text: id
    select.removeAttr('disabled').select2 options
    if initial_values?
      select.val(initial_values).trigger('change')
    @init_editor select, "popup-editor"

  init_select2_boolean: (select, initial_values) =>
    select.destroySelect2 clear:true
    select.removeAttr('disabled').select2({
      data: [true, false, 'null']
    })
    if initial_values?
      select.val(initial_values).trigger('change')
    @init_editor select, ""

  init_select2_enum: (select, field_code, initial_values) =>
    initializer = (options) =>
      select.destroySelect2 clear:true
      select.removeAttr('disabled').select2(options)
      if initial_values?
        select.val(initial_values).trigger('change')
      @init_editor select, "popup-editor,select-all"

    options = {
      tags: true,
      tokenSeparators: @select2_token_separators,
      minimumInputLength: 0,
    }

    if _.isArray @parent.enums[field_code]
      options['data'] = @parent.enums[field_code]
      initializer(options)
    else
      group = select.closest "[#{@parent.attr}-group]"
      $.ajax {
        url: @url_get_list
        data:
          dataset: @controller.get_dataset_code()
          field: field_code
        dataType: 'json',
        method: 'POST'
        beforeSend: () =>
          select.select2()
          select.showLoader()
        complete: () =>
          select.hideLoader()
        success: (data) =>
          if _.isObject(data) and _.isArray(data.items)
            @parent.enums[field_code] = data.items
            options['data'] = @parent.enums[field_code]
            if initial_values
              for value in initial_values
                item = options['data'].find (o) =>
                  o.id.toString() == value.toString()
                if !item
                  options['data'].push({id: value, text: value})
            initializer(options)
      }

  init_select2_object: (select, field_code, initial_values) =>
    initializer = () =>
      select.removeAttr('disabled').select2({
        tags: true,
        tokenSeparators: @select2_token_separators,
        minimumInputLength: 0,
        ajax: {
          url: @url_get_list
          data: (params) =>
            q: params.term
            dataset: @controller.get_dataset_code()
            field: field_code
          dataType: 'json',
          method: 'POST'
          delay: @search_delay
          cache: true
          processResults: (data, params) =>
            return {
              results: data.items
            }
        }
      })
      @init_editor select, "popup-editor,select-all"

    if !initial_values?
      select.destroySelect2 clear:true
      initializer()
    else
      $.ajax {
        url: @url_get_list,
        data:
          dataset: @controller.get_dataset_code()
          field: field_code,
          values: initial_values,
          limit: Math.max(100, initial_values.length)
        dataType: 'json',
        method: 'POST'
        beforeSend: () =>
          select.select2()
          select.showLoader()
        complete: () =>
          select.hideLoader()
        success: (data) =>
          if _.isObject(data) and _.isArray(data.items)
            select.destroySelect2 clear:true
            if initial_values
              for value in initial_values
                item = data.items.find (o) =>
                  o.id.toString() == value.toString()
                if item
                  option = {id: item.id, text: item.text}
                else
                  option = {id: value, text: value}
                select.append """
                  <option value="#{encodeURIComponent(option.id)}" selected="selected">
                    #{option.text}
                  </option>
                """
            else
              for item in data.items
                select.append """
                  <option value="#{encodeURIComponent(item.id)}" selected="selected">
                    #{item.text}
                  </option>
                """
            initializer()
      }
